export const FormTemplate = [  
  {
     "id": 35,
     "form_template": {
      "name": {
        "en": "",
        "es": "",
        "de": "",
        "nl": "",
        "it": "",
        "fr": "",
        "cn": ""
      },
      "content": [
        {
          "id": "kdmm1yn6",
          "type": "FormFrame",
          "title": {
            "color": "#ffffff",
            "display": "none",
            "padding": "15px",
            "fontSize": 20,
            "textAlign": "center",
            "fontWeight": "300",
            "backgroundColor": "#2a2d51"
          },
          "content": {
            "de": "Test Titelformular-Rahmen",
            "en": "Test title form frame",
            "it": "Telaio del titolo del test",
            "nl": "Testtitel kader"
          },
          "children": [
            {
              "id": "kdplhieb",
              "page": 1,
              "type": "Container",
              "style": {
                "backgroundColor": "transparent"
              },
              "mapWith": "form-container",
              "children": [
                {
                  "id": "kdn9iwjz",
                  "type": "Row",
                  "mapWith": "form-content",
                  "children": [
                  ]
                },
                {
                  "id": "li0e65rs",
                  "type": "div",
                  "children": [
                    {
                      "id": "li0e65rt",
                      "type": "div",
                      "style": {
                        "display": "flex",
                        "marginBottom": "1rem",
                        "flexDirection": "row",
                        "justifyContent": "flex-end",
                        "@media ( max-width: 768px )": {
                          "justifyContent": "flex-start"
                        }
                      },
                      "children": [
                        {
                          "id": "li0e65rq",
                          "type": "button",
                          "style": {
                            "color": "#ffffff",
                            "width": "100%",
                            ":hover": {
                              "color": "#000000",
                              "border": "1px solid #000000",
                              "background": "#ffffff"
                            },
                            "border": "1px solid #ffffff",
                            "outline": "none",
                            "padding": "5px 8px",
                            "background": "#202B48",
                            "transition": "0.3s linear all",
                            "borderRadius": "0rem"
                          },
                          "children": [
                            {
                              "id": "li0e65rr",
                              "type": "div",
                              "style": {
                                "zIndex": 2,
                                "position": "relative"
                              },
                              "content": {
                                "de": "Absenden",
                                "en": "Submit",
                                "it": "Invia",
                                "nl": "Indienen"
                              },
                              "variant": "text"
                            }
                          ],
                          "isPublicFileUrl": false
                        }
                      ],
                      "className": "col-md-12"
                    }
                  ],
                  "className": "row"
                }
              ]
            }
          ],
          "container": {
            "borderColor": "#2a2d51",
            "borderWidth": 0
          },
          "totalPages": 1
        }
      ],
      "values": [
        {
          "id": "li0e2z6q",
          "type": "textField",
          "value": "",
          "dataLabel": "li0e2z6q",
          "validation": {
            "de": "",
            "en": "",
            "it": "",
            "nl": ""
          },
          "isEmailTextField": false
        },
        {
          "id": "li0e39gp",
          "type": "textField",
          "value": "",
          "dataLabel": "li0e39gp",
          "validation": {
            "de": "",
            "en": "",
            "it": "",
            "nl": ""
          },
          "isEmailTextField": false
        },
        {
          "id": "li0e3hnb",
          "type": "textarea",
          "value": "",
          "dataLabel": "your_msg",
          "validation": {
            "de": "",
            "en": "",
            "it": "",
            "nl": ""
          },
          "isEmailTextField": false
        }
      ],
      "status": "ACTIVE",
      "email_recipients": {
        "en": "",
        "es": "",
        "de": "",
        "nl": "",
        "it": "",
        "fr": "",
        "cn": ""
      },
      "email_bcc": {
        "en": "",
        "es": "",
        "de": "",
        "nl": "",
        "it": "",
        "fr": "",
        "cn": ""
      },
      "email_subjects": {
        "en": "",
        "es": "",
        "de": "",
        "nl": "",
        "it": "",
        "fr": "",
        "cn": ""
      },
      "send_email_content": {
        "en": "",
        "es": "",
        "de": "",
        "nl": "",
        "it": "",
        "fr": "",
        "cn": ""
      },
      "email_content": {
        "en": "",
        "es": "",
        "de": "",
        "nl": "",
        "it": "",
        "fr": "",
        "cn": ""
      },
      "confirmation_message": {
        "en": "Sind Sie sicher, dass Sie dieses Formular abschicken wollen?",
        "es": "",
        "de": "",
        "nl": "",
        "it": "",
        "fr": "",
        "cn": ""
      },
      "recipient_group_ids": [],
      "site_funnel_id": null
    },
    "component_template_style": {
      "TextArea": {
        "rows": 8,
        "type": "TextArea",
        "label": {
          "de": "",
          "en": "",
          "it": "",
          "nl": ""
        },
        "padding": "15px",
        "children": [],
        "resizable": "None",
        "inputStyle": {
          "border": "none",
          "background": "#F5F5F5",
          "borderRadius": "0px",
          "::placeholder": {
            "color": "#1E285C",
            "fontSize": "18px"
          }
        },
        "placeholder": {
          "de": "Deine Nachricht",
          "en": "Deine Nachricht",
          "it": "Deine Nachricht",
          "nl": "Deine Nachricht"
        },
      },
      "TextField": {
        "label": {
          "de": "",
          "en": "",
          "it": "",
          "nl": ""
        },
        "padding": "15px",
        "children": [],
        "inputStyle": {
          "border": "none",
          "padding": "25px 12px",
          "marginTop": "-15px",
          "background": "#F5F5F5",
          "borderRadius": "0px",
          "::placeholder": {
            "color": "#1E285C",
            "fontSize": "18px"
          }
        },
        "placeholder": {
          "de": "VOR-/NACHNAME",
          "en": "VOR-/NACHNAME",
          "it": "VOR-/NACHNAME",
          "nl": "VOR-/NACHNAME"
        }
      }
    }
  }
]